import cx from 'classnames'
import { PurchaseChannelConfig } from '../types'
import {
  buildPurchaseChannelDisplayStates,
  PurchaseChannelDisplayState,
} from '../utils/purchaseButtonState'

interface PurchaseLinkButtonsProps {
  purchaseChannels: PurchaseChannelConfig[]
  onAmazonClick: () => void
  onRakutenClick: () => void
}

interface StickyPurchaseButtonConfig extends PurchaseChannelDisplayState {
  onClick: () => void
}

function PurchaseButton({ button }: { button: StickyPurchaseButtonConfig }) {
  const buttonClassName = button.isPrimary
    ? 'bg-mi-bg-primary text-white'
    : 'border-[1px] border-solid border-on-surface-accent-primary bg-surface-primary text-on-surface-accent-primary'

  return (
    <a
      id={`sticky-${button.channel}-purchase-button`}
      href={button.href}
      target='_blank'
      rel='noreferrer noopener'
      className={cx(
        'rounded-lg tracking-tight relative w-full text-center block',
        'h-12 text-base font-semibold flex flex-col items-center justify-center',
        buttonClassName,
      )}
      onClick={button.onClick}
    >
      <span className='block'>{button.label}</span>
      {button.subText && (
        <span className='block mt-0.5 text-xs font-light tracking-[-0.08px]'>
          {button.subText}
        </span>
      )}
    </a>
  )
}

export default function PurchaseLinkButtons({
  purchaseChannels,
  onAmazonClick,
  onRakutenClick,
}: PurchaseLinkButtonsProps) {
  const buttons = buildPurchaseChannelDisplayStates(purchaseChannels).map(button => ({
    ...button,
    onClick: button.channel === 'amazon' ? onAmazonClick : onRakutenClick,
  }))

  return (
    <div className='flex gap-2'>
      {buttons.map(button => (
        <PurchaseButton key={button.channel} button={button} />
      ))}
    </div>
  )
}
